module.exports = {
  showFlashMessageTime: 5000,
  spacer: 8,
  transitionDurationDefault: 200,
};
